interface Props {
  resumo: string[]
  passoLabel?: string | undefined
  nested?: boolean
}

export function PassoAgoraSection({ resumo, passoLabel, nested }: Props) {
  if (resumo.length === 0) return null

  return (
    <section
      className={nested ? 'cf3-block cf3-block--nested' : 'cf3-block'}
      aria-labelledby='agora-heading'
    >
      <div>
        {!nested && passoLabel && <p className='cf3-overline'>{passoLabel}</p>}
        <h2 id='agora-heading' className='cf3-subsection-title'>
          O que fazer agora
        </h2>
      </div>
      <div className='cf3-block__card cf3-block__card--accent'>
        <ul className='cf3-acoes-list'>
          {resumo.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      </div>
    </section>
  )
}
